import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostListener, Input, OnDestroy,
    OnInit,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services/user/authentication/authentication.service";
import { LoginComponent } from "../login/login.component";
import { GeographicAreasService } from "src/app/_services/shared/geographic-areas/geographic-areas.service";
import {Subject, Subscription} from "rxjs";
import {UserDetailsService} from "../../../_services/user/user-details.service";
import {takeUntil} from "rxjs/operators";
import { ConfigService } from "src/app/_services/config.service";

@Component({
    selector: "wfdss-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() userIsElevated
  public loggedIn: boolean;
  private username: string;
  private password: string;
  public toolbarOverflowing = false;
  public toolbarOffsetWidthCeiling = null;
  public zoomLevel;
  env = '';  
  
  bannerColor: any;

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: any) {
    this.zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);
    this.zoomLevel > 110
      ? (this.toolbarOverflowing = true)
      : (this.toolbarOverflowing = false);
    this.cdr.detectChanges()
  }
  userLoginSubscription;
  userDetailsSubs: Subscription;
  gaAbbreviation: string;
  gaPrepLevel: number;
  nationalPrepLevel: number;

  destroying$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public authenticationService: AuthenticationService,
    public userDetailsService: UserDetailsService,
    private loginDialog: MatDialog,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private geographicAreasService: GeographicAreasService,
    private environment: ConfigService
  ) {
    this.userLoginSubscription = authenticationService
      .getLoginStatusEvent()
      .subscribe((userLoggedIn) => {
        if (userLoggedIn) {
          this.getPrepLevels();
        }
      });    
  }

  ngOnInit() {
    this.userDetailsSubs = this.userDetailsService
      .userEvent.asObservable().pipe(takeUntil(this.destroying$))
      .subscribe((eventName) => {
          if (eventName === 'currentUserUpdate') {
              this.getPrepLevels();
          }
      });

    this.setBannerColor();
  }

  setBannerColor() {
    const wfdssURL = window.location.href?.toLowerCase();
    let bannerColorCss = '';

    switch(this.environment.name) {
      case 'dev':
        bannerColorCss = '#7A4988'
        break;
      case 'qa':
        bannerColorCss = '#0B6623'
        break;
      case 'uat':
        bannerColorCss = '#000000'
        break;
      case 'oat':
        bannerColorCss = '#000000'
        break;
      case 'edu':
        bannerColorCss = '#4D7740'
        break;
      case 'prd':
        bannerColorCss = '#2E3E4F'
        break;
    }

    this.bannerColor = bannerColorCss;
  }

  ngAfterViewInit(): void {
    this.zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);
    this.zoomLevel > 110
      ? (this.toolbarOverflowing = true)
      : (this.toolbarOverflowing = false);
      this.cdr.detectChanges()
  }

  getPrepLevels() {
    // Http client completes
    this.geographicAreasService
      .getNationalGeographicAreas()
      .subscribe((nationalGa) => {
        const urlFlagNpl = Number(
          new URL(window.location.href).searchParams.get("npl-fflag")
        );

        /** TODO: Remove once testing is completed */
        if (urlFlagNpl > 0) {
          this.nationalPrepLevel = urlFlagNpl;
        } else {
          this.nationalPrepLevel = nationalGa.prepLevel;
        }
      });

    const urlFlagGapl = Number(
      new URL(window.location.href).searchParams.get("gapl-fflag")
    );
    /** TODO: Remove once testing is completed */
    if (urlFlagGapl > 0) {
      this.gaPrepLevel = urlFlagGapl;
    } else {
      this.gaPrepLevel =
        this.authenticationService?.currentUser?.geographicArea?.prepLevel;
    }
    this.gaAbbreviation = this.authenticationService?.currentUser?.geographicArea?.abbreviation;
  }

  // TODO: this will change when we have a login page.
  openDialog() {
    //
    if (!this.authenticationService.isLoggedIn) {
        window.location.href = "/auth/sso"
    } else {
      this.logout();
    }
  }

  logout() {
    this.router.navigate(["/"]).then((success) => {
      if (success || success === null) {
        // navigated or already on dashboard then logout
        this.authenticationService.logout();
      }
    });
  }

  ngOnDestroy(): void {
      this.destroying$.next();
      this.destroying$.complete();
  }
}
